import { Component, OnDestroy, OnInit } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Subscription } from 'rxjs';
import { AbstractBiditComponent } from '../../shared/controls/abstract.bidit.component';
import { AuthService } from '../../shared/services/auth.service';
import { UserService } from '../../user/services/user.service';
import { DashboardSummary } from '../dashboard.summary.interface';
import { HomeService } from '../services/home.service';

@Component({
  selector: 'app-home-mobile',
  templateUrl: './home-mobile.component.html',
  styleUrls: ['./home-mobile.component.scss']
})
export class HomeMobileComponent extends AbstractBiditComponent implements OnInit, OnDestroy {
  summary: DashboardSummary = {} as DashboardSummary;
  showIDI: boolean = false;

  private usernameSubscription: Subscription;

  locale: string = 'en';

  constructor(deviceDetectorService: DeviceDetectorService,
    protected homeService: HomeService, private userService: UserService) {
    super(deviceDetectorService);

    this.usernameSubscription = AuthService.authNavStatus$.subscribe(authenticated => {
      if (authenticated) {
        let user = AuthService._authUserSource.value;
        this.locale = user?.locale ?? 'en';
      }
    });
  }

  ngOnDestroy() {
    this.usernameSubscription.unsubscribe();
  }

  ngOnInit(): void {
    this.showIDI = (HomeService._authNavStatusSource.value == "IDI");

    if (!this.showIDI) {
      let today = new Date();

      let year = today.getFullYear();
      let month = today.getMonth();

      // Convert javascript 0-indexed month num to C# month num
      this.homeService.getDashboardSummary(year, month + 1)
        .subscribe({
          next: (data) => {
            this.summary = data;
          },
          error: (error: string) => this.onError(error)
        });
    }
  }

  updateLocale(): void {
    this.userService.updateLocale(this.locale)
      .subscribe({
        next: (data) => {
          this.userService.loginUser(data);
          window.location.href = `/${this.locale}/index.html`;
        }
      });
  }
}
